<template>
    <app-field :error="error" :classes="classes">
        <app-label v-if="label != ''" :label="label" :required="required" :description="description"></app-label>

        <input type="password" ref="handle" v-bind="$attrs" class="input" :class="options" :value="value" @input="update()" slot="input" />
    </app-field>
</template>

<script>
    /* Components */
    import Field from '@/components/fields/Field';
    import Label from '@/components/fields/Label';

    export default {
        name: 'app-field-password',
        
        components: {
            'app-field': Field,
            'app-label': Label
        },

        props: {
            label: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            description: {
                type: String,
                default: ''
            },
            error: {
                type: String,
                default: ''
            },
            value: {
                default: ''
            },
            classes: {
                type: Object,
                default: () => ({})
            }
        },

        computed: {
            options() {
                let classes = {};

                if(typeof this.classes.input != 'undefined' && Object.keys(this.classes.input).length > 0) {
                    classes = {
                        ...this.classes.input
                    };
                }
                if(this.error != '') {
                    classes['error'] = true;
                }

                return classes;
            }
        },

        methods: {
            update() {
                this.$emit('input', this.$refs.handle.value)
            }
        }
    }
</script>

<style lang="scss">
    @import '../../../sass/modules/inputs.scss';
</style>


// WEBPACK FOOTER //
// src/components/fields/inputs/Password.vue